export const StartIconStyles = {
  position: 'absolute',
  bottom: 5,
  left: 5,
  color: 'grey.500',
} as const;
